import { Languages } from "../../types"
import { AuthTokenValidatorDescriptions } from "./types"

const DescriptionsEnUs: AuthTokenValidatorDescriptions = {
    TITLE: "Token Validator",
    DESCRIPTION: "Please enter the auth token sent to the administrator email.",
    ACCEPT: "Accept",
    CANCEL: "Cancel",
    INPUT_TOKEN: {
        LABEL: "",
        PLACEHOLDER: "Input token",
    },
}

const DescriptionsEsUs: AuthTokenValidatorDescriptions = {
    TITLE: "Validador de Token de Seguridad",
    DESCRIPTION: "Por favoringrese el token enviado al correo administrativo.",
    ACCEPT: "Aceptar",
    CANCEL: "Cancelar",
    INPUT_TOKEN: {
        LABEL: "",
        PLACEHOLDER: "Ingresar token",
    },
}

const authTokenValidatorDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}

export const getAuthTokenValidatorDescriptions = (systemLang: Languages): AuthTokenValidatorDescriptions => (
    authTokenValidatorDictionary[systemLang]
)